<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useRuntimeConfig } from '@/composables/useRuntimeConfig';

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    urlArquivoPdf: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['update:visible']);

const dialogoAberto = computed({
    get: () => props.visible,
    set: (value) => emit('update:visible', value)
});

const authStore = useAuthStore();
const { joinUrl } = useRuntimeConfig();

const urlMontada = computed(() => joinUrl(props.urlArquivoPdf));

</script>

<template>
    <Dialog v-model:visible="dialogoAberto" appendTo="body" modal :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '80vw' }" :draggable="false" :resizable="false" :showHeader="false"
        :contentStyle="{ padding: 0, borderRadius: '1.5rem' }">
        <template #default>
            <div style="position: relative; height: 80vh; contain: inline-size;">
                <Button icon="pi pi-times" size="small" rounded aria-label="Fechar"
                    style="position: absolute; top: 1rem; right: 1rem; z-index: 600;height: 2rem;width: 2rem;padding: 0;background: white; border: 1px solid rgba(0, 0, 0, 0.1); box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); color: black;"
                    @click="dialogoAberto = false" />
                <LeitorPdf :url="urlMontada" :token="authStore.getToken()" />
            </div>
        </template>
    </Dialog>
</template>